import { TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { DeliveryAddress } from '../../types/delivery-selection.type';

type Props = {
  address: DeliveryAddress | null;
  onChange: (address: DeliveryAddress | null) => void;
  editable?: boolean;
  label?: string;
};

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
});

const EMPTY_ADDRESS: DeliveryAddress = {
  type: 'home',
  _id: '',
  address: '',
  zipCode: '',
  city: '',
  complement: '',
  comment: '',
};

export function AddressDisplayForm({ address, onChange, editable = true, label }: Props) {
  const classes = useStyles();
  const current = address ?? EMPTY_ADDRESS;

  const handleChange = (field: keyof DeliveryAddress, value: string) => {
    onChange({ ...current, [field]: value });
  };

  return (
    <div className={classes.root}>
      {label && <h4>{label}</h4>}
      <TextField
        disabled={!editable}
        label="Adresse"
        variant="outlined"
        value={current.address}
        onChange={(e) => handleChange('address', e.target.value)}
      />
      <TextField
        disabled={!editable}
        label="Code postal"
        variant="outlined"
        value={current.zipCode}
        onChange={(e) => handleChange('zipCode', e.target.value)}
      />
      <TextField
        disabled={!editable}
        label="Ville"
        variant="outlined"
        value={current.city}
        onChange={(e) => handleChange('city', e.target.value)}
      />
      <TextField
        label="Complément d'adresse"
        variant="outlined"
        multiline
        maxRows={4}
        value={current.complement ?? ''}
        onChange={(e) => handleChange('complement', e.target.value)}
      />
      <TextField
        label="Commentaire"
        variant="outlined"
        multiline
        maxRows={4}
        value={current.comment ?? ''}
        onChange={(e) => handleChange('comment', e.target.value)}
      />
    </div>
  );
}
